module.exports = __webpack_public_path__ + "static/media/mendoza.def37125.jpg";